export default "__VITE_ASSET__neKTOkmr__"